const INVENTORY_TYPE = Object.assign(
    type => Object.values(INVENTORY_TYPE).find(value => value === type) || INVENTORY_TYPE[type],
    {
        DIGITAL: 'digital',
        STATIC: 'static',
    }
);

export default INVENTORY_TYPE;
